export { default as TableHead } from "./component";
